import React from 'react';
import { makeStyles } from '@mui/styles';
import { SyncLoader } from 'react-spinners';
import callCenter from '../assets/img/call-center.png';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        padding: '20px',
        flexDirection: 'column',
        minHeight: '387px',
        width: '100%',
        position: 'absolute',
        zIndex: 9,
        textAlign: 'center',
        fontFamily: '"Inter", sans-serif',
        boxSizing: 'border-box',
        borderRadius: '16px'
    },

    spinner: {
        margin: '20px 0',
    },
    title: {
      fontSize: '18px',
      lineHeight: '24px',
    },
    message: {
        fontSize: '14px',
        color: '#555F6D',
        maxWidth: '271px'
    },
    bg: {
        background: '#0000004F',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 9
    }
}));

const HandoffMessage = ({ customMessage }) => {
    const classes = useStyles();

    const { title, body } = {
        title: customMessage?.title || 'Connecting you with an agent...',
        body: customMessage?.body || 'This might take a few seconds, please do not close this window.'
    }

    return (
        <>
            <div className={classes.bg} />
            <div className={classes.container}>
                <img src={callCenter} className={classes.img}/>
                <SyncLoader color="#2356F6" size={9} className={classes.spinner} speedMultiplier={.5} />
                <div className={classes.title}>{title}</div>
                <p className={classes.message}>{body}</p>
            </div>
        </>

    );
};

export default HandoffMessage;
